import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getTranslations, LANGUAGES } from "@/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("bridgette_lang");
    if (saved && LANGUAGES.find(l => l.code === saved)) return saved;
    const browserLang = navigator.language?.slice(0, 2);
    if (LANGUAGES.find(l => l.code === browserLang)) return browserLang;
    return "en";
  });

  const t = getTranslations(lang);
  const dir = t.dir || "ltr";

  useEffect(() => {
    localStorage.setItem("bridgette_lang", lang);
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [lang, dir]);

  const switchLanguage = useCallback((code) => {
    if (LANGUAGES.find(l => l.code === code)) setLang(code);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, dir, switchLanguage, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "en", t: getTranslations("en"), dir: "ltr", switchLanguage: () => {}, languages: LANGUAGES };
  return ctx;
}
